import { ajax } from './createApi'
import { truckBaseUrl } from './urlConfig'

/**
 *
 * 获取用户可以认证的身份数据
 * @export
 * @returns
 */
export function getIdentityInfo () {
  return ajax({
    method: 'GET',
    url: `${truckBaseUrl}/identification/getIdentityInfo`,
    data: null
  })
}

/**
 *
 * 更新用户的身份信息
 * @export
 * @returns
 */
export function updateIdentityInfo (data) {
  return ajax({
    method: 'GET',
    url: `${truckBaseUrl}/identification/refreshIdentity`,
    data
  })
}

/**
 *
 * 创建用户的车主认证信息 个人/企业
 * @export
 * @param {*} data
 */
export function createVehicleAuth (data) {
  return ajax({
    method: 'POST',
    url: `${truckBaseUrl}/identification/vehicleAuth`,
    data
  })
}

/**
 *
 * 创建用户的车主认证信息 个人/企业
 * @export
 * @param {*} data
 */
export function createDriverAuth (data) {
  return ajax({
    method: 'POST',
    url: `${truckBaseUrl}/identification/driverAuth`,
    data
  })
}
/**
 *
 * 获取认证的草稿的信息
 * @export
 * @returns
 */
export function getAuthInfoDraft () {
  return ajax({
    method: 'GET',
    url: `${truckBaseUrl}/identification/getAuthInfoDraft`,
    data: null
  })
}

/**
 *
 * 车主认证提交请求中交认证
 * @export
 * @param {*} data 提交的数据
 * @returns
 */
export function createZyOwnerAuth (data) {
  return ajax({
    method: 'POST',
    url: `${truckBaseUrl}/identification/zyOwnerAuth`,
    data
  })
}